<div class="container-fluid">
      <hr>
      <div class="row" style="background-color: #444444;text-align: center">
        <div class="col-md-7" style="
       font-family: 'PT Sans', sans-serif;font-size: 26px;margin:40px;color: white;font-weight: bold;"
        >If You want to See my resume in paper,This is it. Check it out !!</div>
        <div class="col-md-1"></div>
        <div class="col-md-2" style="
        font-size: 50px;margin:20px">
          <button type="button" class="btn btn-outline-info" style="
padding: 20px;
    color: white;
    font-size: 16px;
    font-weight: bold;
    border: 3px solid #c5c5c5;
      font-family: 'PT Sans', sans-serif;"> <i class="fa fa-files-o"></i> My Cirriculum</button>


        </div>
      </div>
      <hr>
</div>


